export const GRAPH_URL = "https://api.musafira2z.com/graphql/";